<template>
  <div class="root-ondemand-banner"
       :class="borderColor">
    <component :is="activeComponent"
               :status-text="statusText"
               class="root-ondemand-banner__content"
               @hide-banner="$emit('hide-banner')"/>
  </div>
</template>

<script>
  import PendingBanner from '@/components/banners/ondemand/banner-pending.vue';
  import AwaitingPaymentBanner from '@/components/banners/ondemand/banner-awaiting-payment.vue';
  import AcceptBanner from '@/components/banners/ondemand/banner-accept.vue';
  import GeneralBanner from '@/components/banners/ondemand/banner-general.vue';
  import {ONDEMAND_STATUSES} from '@/reference/ondemand.js';

  export default {
    name: 'root-ondemand-banner',
    props: {
      status: {type: Number},
    },
    computed: {
      activeComponent() {
        const bannerStatuses = {
          [ONDEMAND_STATUSES.PENDING]: PendingBanner,
          [ONDEMAND_STATUSES.PAYMENT]: AwaitingPaymentBanner,
          [ONDEMAND_STATUSES.ACCEPT]: AcceptBanner,
        };

        if (bannerStatuses[this.status]) {
          return bannerStatuses[this.status];
        }

        return GeneralBanner;
      },
      borderColor() {
        if (this.status === ONDEMAND_STATUSES.PENDING) return 'border-purple';
        if (this.status === ONDEMAND_STATUSES.PAYMENT) return 'border-red';
        if (this.status === ONDEMAND_STATUSES.ACCEPT) return 'border-green';

        return 'border-gray';
      },
      statusText() {
        if (this.status === ONDEMAND_STATUSES.REJECT) return 'Request Declined';
        if (this.status === ONDEMAND_STATUSES.CANCELLED) return `You <span class="crimson">cancelled</span> the request`;
        if (this.status === ONDEMAND_STATUSES.AUTOCANCELLED) return `<span class="purple">Automatically</span> cancelled`;
        if (this.status === ONDEMAND_STATUSES.PAYMENT_AUTOCANCELLED) return `Booking <span class="crimson">Cancelled</span>`;

        return '';
      },
    },
    ONDEMAND_STATUSES,
  }
</script>

<style lang="scss">
  .root-ondemand-banner {
    height: 78px;
    border-top: 1px solid;
    border-bottom: 1px solid;
    cursor: pointer;

    &.border-purple {
      border-color: rgba(#736FDC80, 0.5);
    }

    &.border-red {
      border-color: rgba(#DA2525, 0.5);
    }

    &.border-green {
      border-color: rgba(#0FB16D, 0.5);
    }

    &.border-gray {
      border-color: rgba(color(gray-400), 0.5);
    }

    &__content {
      padding: 0 20px;
      height: 100%;
    }
  }
</style>
